export default __webpack_public_path__ + "static/media/Wat zou er aanzitten.133b92f7.jpg";